module.exports = __webpack_public_path__ + "static/resources-img-2-4a6c1ccd95732c071dc3e390009b4b05.png";